import React from "react";
import { RetificacaoContext } from "./RetificacaoContext";

function RetificacaoProvider(props) {
  var state = React.useState(null);

  return React.createElement(
    RetificacaoContext.Provider,
    {
      value: {
        dadosRetificacao: state[0],
        setDadosRetificacao: state[1],
      },
    },
    props.children
  );
}

export default RetificacaoProvider;
